import React from 'react';
import './ServicePage.css';

import { Heading, Service, PageTitle } from '../../../components';
import { services } from '../../../constants';
 
// Import Swiper styles  
import 'swiper/css'; 
import 'swiper/css/pagination';



const ServicePage = () => { 

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Services'} page={'Services'} />

      <section className='services'>

        {/* Section heading */}
        <Heading title={'our services'} subTitle={'what we offer'} />

        <div className='box-container'>

          {/* Map over the services array to render each service */}
          {services.map((service) => { 
            return (
              <Service
                key={service.id}
                image={service.image}
                title={service.title}
                content={service.content}
                service={service}
              />
            );
          })}
        </div>

      </section>

    </>

  )
}

export default ServicePage;